import { ReactNode } from 'react'
import Box from '@mui/material/Box'

interface TabPanelProps {
	children?: ReactNode
	index: number | string
	value: number | string
}

export function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tab-panel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ py: 3 }}>{children}</Box>}
		</div>
	)
}